import type { GameSettings, InputBindings } from './types';

export const GAME_TITLE = 'SLIPSTREAM FORGE';
export const SAVE_KEY = 'slipstream-forge-save-v1';

export const DEFAULT_BINDINGS: InputBindings = {
  accelerate: ['KeyW', 'ArrowUp'],
  brake: ['KeyS', 'ArrowDown'],
  left: ['KeyA', 'ArrowLeft'],
  right: ['KeyD', 'ArrowRight'],
  handbrake: ['Space'],
  restart: ['KeyR'],
  reset: ['Backspace'],
  pause: ['Escape'],
};

export const DEFAULT_SETTINGS: GameSettings = {
  resolution: '1600x900',
  fullscreen: false,
  vsync: true,
  sceneryDensity: 'high',
  masterVolume: 0.8,
  effectsVolume: 0.85,
  engineVolume: 0.7,
  speedUnit: 'mph',
  bindings: DEFAULT_BINDINGS,
};

export const FIXED_TIMESTEP = 1 / 120;
export const MAX_FRAME_DELTA = 0.05;
export const GRAVITY = 24;
export const BOOST_DURATION = 0.8;
export const BOOST_ACCELERATION = 28;
export const RESET_LOCK_SECONDS = 0.22;
